import { graphClient } from "../graph-client";
import {
  CREATE_AGENCY_SALE_DETAIL,
  GET_AGENCIES_SALES_DETAILS,
  GET_AGENCIES_SALES_DETAILS_TOTAL,
  REVERSE_AGENCY_SALE_DETAIL,
} from "./gql";
import { Create, GetList, Reverse, Total } from "./types";

export class AgencySaleDetail {
  async create(params: Create.Input) {
    const request = await graphClient.request<Create.Output>(
      CREATE_AGENCY_SALE_DETAIL,
      {
        ...params,
      }
    );

    return request?.createAgencySaleDetail;
  }

  async getList(params: GetList.Input) {
    const request = await graphClient.request<GetList.Output>(
      GET_AGENCIES_SALES_DETAILS,
      { ...params }
    );

    return request?.getAgenciesSalesDetails;
  }

  async reverse(params: Reverse.Input) {
    const request = await graphClient.request<Reverse.Output>(
      REVERSE_AGENCY_SALE_DETAIL,
      { ...params }
    );

    return request?.reverseAgencySaleDetail;
  }

  async getTotal(params: Total.Input) {
    const request = await graphClient.request<Total.Output>(
      GET_AGENCIES_SALES_DETAILS_TOTAL,
      { ...params }
    );

    return request?.getAgenciesSalesDetailsTotal;
  }
}

export const agencySaleDetail = new AgencySaleDetail();
